// Asset without campaign details
export const ASSET_WITHOUT_CAMPAIGN_DETAILS = {
  LOAD: "ASSET_WITHOUT_CAMPAIGN_DETAILS_LOAD",
  SUCCESS: "ASSET_WITHOUT_CAMPAIGN_DETAILS_LOAD_SUCCESS",
  FAIL: "ASSET_WITHOUT_CAMPAIGN_DETAILS_LOAD_FAIL",
  RESET: "ASSET_WITHOUT_CAMPAIGN_DETAILS_LOAD_RESET",
  SET_DRAFT_NAME: "ASSET_WITHOUT_CAMPAIGN_DETAILS_SET_DRAFT_NAME",
};

export const ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME = {
  LOAD: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME_LOAD",
  SUCCESS: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME_SUCCESS",
  FAIL: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME_FAIL",
  RESET: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME_RESET",
};

export const ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS = {
  LOAD: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS_LOAD",
  SUCCESS: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS_SUCCESS",
  FAIL: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS_FAIL",
  RESET: "ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS_RESET",
};

export const ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT = {
  LOAD: "ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT_LOAD",
  SUCCESS: "ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT_SUCCESS",
  FAIL: "ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT_FAIL",
  RESET: "ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT_RESET",
};

export const ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT = {
  LOAD: "ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT_LOAD",
  SUCCESS: "ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT_SUCCESS",
  FAIL: "ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT_FAIL",
  RESET: "ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT_RESET",
};

// Asset details

export const ASSET_DETAILS = {
  LOAD: "ASSET_DETAILS_LOAD",
  SUCCESS: "ASSET_DETAILS_LOAD_SUCCESS",
  FAIL: "ASSET_DETAILS_LOAD_FAIL",
  RESET: "ASSET_DETAILS_LOAD_RESET",
  UPDATE_SUBJECT: "ASSET_DETAILS_UPDATE_SUBJECT",
  DRAFT_EDITIONS_SUCCESS: "ASSET_DETAILS_DRAFT_EDITIONS_SUCCESS",
  SET_ACTIVE_STATE: "ASSET_DETAILS_SET_ACTIVE_STATE",
  SEARCH_TERMS: "ASSET_DETAILS_SEARCH_TERMS",
};

export const ASSET_SENT_EDITIONS = {
  LOAD: "ASSET_SENT_EDITIONS_LOAD",
  SUCCESS: "ASSET_SENT_EDITIONS_SUCCESS",
  FAIL: "ASSET_SENT_EDITIONS_FAIL",
  RESET: "ASSET_SENT_EDITIONS_RESET",
};

export const ASSET_SEARCH_SENT_EDITIONS = {
  LOAD: "ASSET_SEARCH_SENT_EDITIONS_LOAD",
  SUCCESS: "ASSET_SEARCH_SENT_EDITIONS_SUCCESS",
  FAIL: "ASSET_SEARCH_SENT_EDITIONS_FAIL",
  RESET: "ASSET_SEARCH_SENT_EDITIONS_RESET",
  SET_SEARCH_TERM: "ASSET_SEARCH_SENT_EDITIONS_SET_SEARCH_TERM",
};

export const ASSET_DETAILS_UPDATE_NAME = {
  LOAD: "ASSET_DETAILS_UPDATE_NAME_LOAD",
  SUCCESS: "ASSET_DETAILS_UPDATE_NAME_SUCCESS",
  FAIL: "ASSET_DETAILS_UPDATE_NAME_FAIL",
  RESET: "ASSET_DETAILS_UPDATE_NAME_RESET",
};

export const ASSET_DETAILS_UPDATE_KEYWORDS = {
  LOAD: "ASSET_DETAILS_UPDATE_KEYWORDS_LOAD",
  SUCCESS: "ASSET_DETAILS_UPDATE_KEYWORDS_SUCCESS",
  FAIL: "ASSET_DETAILS_UPDATE_KEYWORDS_FAIL",
  RESET: "ASSET_DETAILS_UPDATE_KEYWORDS_RESET",
};

export const ASSET_DETAILS_ADD_NEW_DRAFT = {
  LOAD: "ASSET_DETAILS_ADD_NEW_DRAFT_LOAD",
  SUCCESS: "ASSET_DETAILS_ADD_NEW_DRAFT_SUCCESS",
  FAIL: "ASSET_DETAILS_ADD_NEW_DRAFT_FAIL",
  RESET: "ASSET_DETAILS_ADD_NEW_DRAFT_RESET",
};
export const ASSET_DETAILS_NAME = {
  UPDATE: "ASSET_DETAILS_NAME_UPDATE",
};

export const ASSET_DETAILS_UPDATE_DRAFT = {
  LOAD: "ASSET_DETAILS_UPDATE_DRAFT_LOAD",
  SUCCESS: "ASSET_DETAILS_UPDATE_DRAFT_SUCCESS",
  FAIL: "ASSET_DETAILS_UPDATE_DRAFT_FAIL",
  RESET: "ASSET_DETAILS_UPDATE_DRAFT_RESET",
  SET_VERSION_SUBJECT_SUCCESS: "ASSET_DETAILS_UPDATE_DRAFT_SET_VERSION_SUBJECT_SUCCESS",
};

export const ASSET_DETAILS_REMOVE_DRAFT = {
  LOAD: "ASSET_DETAILS_REMOVE_DRAFT_LOAD",
  SUCCESS: "ASSET_DETAILS_REMOVE_DRAFT_SUCCESS",
  FAIL: "ASSET_DETAILS_REMOVE_DRAFT_FAIL",
  RESET: "ASSET_DETAILS_REMOVE_DRAFT_RESET",
};

// Editions types
export const EDITION_NAME_CHANGE = {
  LOAD: "EDITION_NAME_CHANGE_LOAD",
  SUCCESS: "EDITION_NAME_CHANGE_SUCCESS",
  FAIL: "EDITION_NAME_CHANGE_FAIL",
  RESET: "EDITION_NAME_CHANGE_RESET",
  ASSET_NAME_UPDATE: "EDITION_NAME_ASSET_NAME_UPDATE",
  CURATED_COUNT_UPDATE: "CURATED_COUNT_UPDATE",
};

export const EDITION_SUBJECT_CHANGE = {
  LOAD: "EDITION_SUBJECT_CHANGE_LOAD",
  SUCCESS: "EDITION_SUBJECT_CHANGE_SUCCESS",
  FAIL: "EDITION_SUBJECT_CHANGE_FAIL",
  RESET: "EDITION_SUBJECT_CHANGE_RESET",
};
